import { render, staticRenderFns } from "./BarComanda.vue?vue&type=template&id=711b7da1&scoped=true"
import script from "./BarComanda.vue?vue&type=script&lang=js"
export * from "./BarComanda.vue?vue&type=script&lang=js"
import style0 from "./BarComanda.vue?vue&type=style&index=0&id=711b7da1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711b7da1",
  null
  
)

export default component.exports